/**
 * Hideable goals-table columns (column show/hide).
 *
 * Single source of truth for which goals-table columns the user can toggle. The
 * `id`s MUST match the `isHidden(id)` gates + hide buttons in GoalsTable, and the
 * `key`-based COLUMNS descriptor there (the ids reuse the GoalSortKey strings).
 * The Goal (name) and Actions columns are intentionally PINNED — not listed here,
 * so they can never be hidden. The shared show/hide primitives live in
 * ../shared/columnVisibility.
 */
import type { HideableColumn } from "../shared/columnVisibility";

export const GOAL_HIDEABLE_COLUMNS: HideableColumn[] = [
  { id: "status", label: "Status" },
  { id: "progress", label: "Progress" },
  { id: "client", label: "Client" },
  { id: "platform", label: "Platform" },
  { id: "metric", label: "Metric" },
  { id: "interval", label: "Interval" },
];
